module.exports = __webpack_public_path__ + "img/z-icon-logo3.95e0d236.png";